/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';

    export interface IDataRemaining {
        value: number;
        unit: string;
        planPercentage?: number;
        originalValue?: number;
    }

    export interface ISIM {
        href: string;
        iccid: string;
        pin?: number;
        puk?: number;
        simPlan: Models.ISimPlan;
        simPlanEndDate?: Date;
        networkNodeModem: Models.NetworkNodeModemAdapter | Models.INetworkNodeModem;
        billingCycle?: number;
        localization?: string;
        creationDate: Date;
        remainingData?: number;
    }

    export interface ISIMDataUsages {
        date: Date | string;
        operationType: "SUB" | "ADD" | "INI";
        operationValue: number;
        receivedValue: number;
        onlySent: number;
        signedOperationValue: number;
        balance?: number;
    }

    export interface ISIMDataRemainingChartPoint {
        value: number;
        x: number;
        timestamp: number;
        xDate: Date;
        day: string;
    }

    export interface ISIMDataRemainingChart {
        values: ISIMDataRemainingChartPoint[];
        init: number;
        end: number;
        res: number;
        stepSize: number;
        maxValue?: number;
        minValue?: number;
    }

    export interface ISIMDataUsageChartPoint {
        value: number;
        x: number;
        xDate: Date;
        timestamp: number;
        day: string;
    }

    export interface ISIMDataUsageChart {
        values: ISIMDataUsageChartPoint[];
        init: number;
        end: number;
        res: number;
        stepSize: number;
        maxValue?: number;
        minValue?: number;
    }

    export interface ISIMDashboardData {
        noPlanSims: number;
        lowDataRemainingSims: number;
        medDataRemainingSims: number;
        higDataRemainingSims: number;
        topSimPlans: ISIMTopPlan[];
    }

    export interface ISIMTopPlan {
        simPlanName: string;
        simPlanOperator: string;
        simPlanData: number;
        simsCount: number;
    }

    export class SIM implements ISIM {
        public href: string;
        public iccid: string;
        public simPlan: Models.ISimPlan;
        public creationDate: Date;
        public networkNodeModem: Models.NetworkNodeModemAdapter | Models.INetworkNodeModem;

        public static Empty(): SIM {
            return new SIM();
        }

        public static Copy(sim: ISIM): SIM {
            let newSim: ISIM = new SIM();
            newSim.href = sim.href;
            newSim.creationDate = sim.creationDate;
            newSim.iccid = sim.iccid;
            newSim.simPlan = sim.simPlan;
            newSim.pin = sim.pin;
            newSim.puk = sim.puk;
            newSim.simPlanEndDate = sim.simPlanEndDate;
            newSim.networkNodeModem = sim.networkNodeModem;
            newSim.billingCycle = sim.billingCycle;
            newSim.localization = sim.localization;
            newSim.remainingData = sim.remainingData;
            return newSim;
        }

        public static getDefaultOrderColumn(): string {
            return "creationDate";
        }

        constructor() {
            // empty constructor
            this.href = '';
            this.iccid = undefined;
            this.creationDate = new Date();
        }
    }

    export class SIMDataUsages implements ISIMDataUsages {
        public date: Date | string;
        public operationType: "ADD" | "SUB" | "INI";
        public operationValue: number;
        public receivedValue: number;
        public onlySent: number;
        public signedOperationValue: number;
        public balance: number;

        public static Empty(): SIMDataUsages {
            return new SIMDataUsages();
        }

        constructor() {
            this.balance = 0;
        }
    }
}
